import ArticleLayout from '@/components/base/ArticleLayout';
import { allArticles } from '@/mocks/seoArticles';

export default function QcPhotoGuidaPage() {
  return <ArticleLayout data={allArticles['qc-photo-guida']} />;
}